import request from '@/utils/request'
import request60 from '@/utils/request60'
import { getToken } from '../utils/auth'

// 机构查询养老服务对象老人档案信息
export function queryelderly (params, data) {
  params.token = getToken()
  return request({ url: '/queryelderly', method: 'post', params, data })
}
// 按照人名搜索老人，支持分页
export function searchelderly (params, data) {
  params.token = getToken()
  return request({ url: '/searchelderly', method: 'post', params, data })
}
// 查询机构与老人的服务内容及关系信息
export function queryentityelderlyservice (data) {
  return request({ url: '/queryentityelderlyservice', method: 'post', params: { token: getToken() }, data })
}
// 新增老人
export function createelderly (data) {
  return request({ url: '/createelderly', method: 'post', params: { token: getToken() }, data })
}
// 更新老人
export function updateelderly (data) {
  return request({ url: '/updateelderly', method: 'post', params: { token: getToken() }, data })
}
// 删除老人
export function deleteelderly (data) {
  return request({ url: '/deleteelderly', method: 'post', params: { token: getToken() }, data })
}
// 查询老人联系人
export function queryelderlyfamilyperson (data) {
  return request({ url: '/queryelderlyfamilyperson', method: 'post', params: { token: getToken() }, data })
}
// 新增老人联系人
export function createelderlyfamilyperson (data) {
  return request({ url: '/createelderlyfamilyperson', method: 'post', params: { token: getToken() }, data })
}
// 更新老人联系人
export function updateelderlyfamilyperson (data) {
  return request({ url: '/updateelderlyfamilyperson', method: 'post', params: { token: getToken() }, data })
}
// 删除老人联系人
export function deleteelderlyfamilyperson (data) {
  return request({ url: '/deleteelderlyfamilyperson', method: 'post', params: { token: getToken() }, data })
}
// 根据id查询老人
export function queryelderlybyid (data) {
  return request({ url: '/queryelderlybyid', method: 'post', params: { token: getToken() }, data })
}
// 创建老人评估信息
export function createelderlyassessmentinfo (data) {
  return request({ url: '/createelderlyassessmentinfo', method: 'post', params: { token: getToken() }, data })
}
// 编辑老人评估信息
export function updateelderlyassessmentinfo (data) {
  return request({ url: '/updateelderlyassessmentinfo', method: 'post', params: { token: getToken() }, data })
}
// 查询老人评估信息
export function queryelderlyassessmentinfo (data) {
  return request({ url: '/queryelderlyassessmentinfo', method: 'post', params: { token: getToken() }, data })
}
// 查询老人评估历史列表
export function queryelderlyassessmenthistory (data) {
  return request({ url: '/queryelderlyassessmenthistory', method: 'post', params: { token: getToken() }, data })
}
// 根据组织id查询机构
export function queryentity (data) {
  return request({ url: '/queryentity', method: 'post', params: { token: getToken() }, data })
}
// 创建机构实体
export function createentity (data) {
  return request({ url: '/createentity', method: 'post', params: { token: getToken() }, data })
}
// 更新机构实体
export function updateentity (data) {
  return request({ url: '/updateentity', method: 'post', params: { token: getToken() }, data })
}
// 根据机构id获取机构实体
export function queryentitybyeid (data) {
  return request({ url: '/queryentitybyeid', method: 'post', params: { token: getToken() }, data })
}
// 根据orgid查询房间
export function queryorghomebyorgid (params, data) {
  params.token = getToken()
  return request({ url: '/queryorghomebyorgid', method: 'post', params, data })
}
// 查询房间 增 删 改 跟之前得家庭接口一样
export function queryorghomepage (params) {
  params.token = getToken()
  return request({ url: '/queryorghomepage', method: 'post', params })
}
// 查询房间床位
export function queryhomebed (data) {
  return request({ url: '/queryhomebed', method: 'post', params: { token: getToken() }, data })
}
// 创建房间
export function createhomebed (data) {
  return request({ url: '/createhomebed', method: 'post', params: { token: getToken() }, data })
}
// 更新房间床位
export function updatehomebed (data) {
  return request({ url: '/updatehomebed', method: 'post', params: { token: getToken() }, data })
}
// 删除房间床位
export function deletehomebed (data) {
  return request({ url: '/deletehomebed', method: 'post', params: { token: getToken() }, data })
}

// 查询机构人员信息
export function queryserviceperson (params, data) {
  params.token = getToken()
  return request({ url: '/queryserviceperson', method: 'post', params, data })
}
// 新增机构人员信息
export function createserviceperson (data) {
  return request({ url: '/createserviceperson', method: 'post', params: { token: getToken() }, data })
}
// 更新机构人员信息
export function updateserviceperson (data) {
  return request({ url: '/updateserviceperson', method: 'post', params: { token: getToken() }, data })
}
// 删除机构人员信息
export function deleteserviceperson (data) {
  return request({ url: '/deleteserviceperson', method: 'post', params: { token: getToken() }, data })
}
// 查询老人老年卡信息
export function queryelderlycardinfo (data) {
  return request({ url: '/queryelderlycardinfo', method: 'post', params: { token: getToken() }, data })
}
// 新增老人老年卡信息
export function createelderlycardinfo (data) {
  return request({ url: '/createelderlycardinfo', method: 'post', params: { token: getToken() }, data })
}
// 更新老人老年卡信息
export function updateelderlycardinfo (data) {
  return request({ url: '/updateelderlycardinfo', method: 'post', params: { token: getToken() }, data })
}
// 删除老人老年卡信息
export function deleteelderlycardinfo (data) {
  return request({ url: '/deleteelderlycardinfo', method: 'post', params: { token: getToken() }, data })
}
// 查询轮候登记
export function queryelderlyappointment (params, data) {
  params.token = getToken()
  return request({ url: '/queryelderlyappointment', method: 'post', params, data })
}
// 查询账户变动信息
export function queryelderlyfinanceorder (params, data) {
  params.token = getToken()
  return request({ url: '/queryelderlyfinanceorder', method: 'post', params, data })
}
// 账户充值
export function addelderlyfinanceorder (data) {
  return request({ url: '/addelderlyfinanceorder', method: 'post', params: { token: getToken() }, data })
}
// 账户退款
export function refundelderlyfinanceorder (data) {
  return request({ url: '/refundelderlyfinanceorder', method: 'post', params: { token: getToken() }, data })
}
// 收费项目表
export function queryfinanceproject (params, data) {
  params.token = getToken()
  return request({ url: '/queryfinanceproject', method: 'post', params, data })
}
// 新增收费项目
export function createfinanceproject (data) {
  return request({ url: '/createfinanceproject', method: 'post', params: { token: getToken() }, data })
}
// 更新收费项目
export function updatefinanceproject (data) {
  return request({ url: '/updatefinanceproject', method: 'post', params: { token: getToken() }, data })
}
// 删除收费项目
export function deletefinanceproject (data) {
  return request({ url: '/deletefinanceproject', method: 'post', params: { token: getToken() }, data })
}
// 查询老人收费项目
export function queryelderlyfinanceproject (params, data) {
  params.token = getToken()
  return request({ url: '/queryelderlyfinanceproject', method: 'post', params, data })
}
// 设置老人收费项目
export function setelderlyfinanceproject (data) {
  return request({ url: '/setelderlyfinanceproject', method: 'post', params: { token: getToken() }, data })
}
// 修改老人收费项目
export function updateelderlyfinanceproject (data) {
  return request({ url: '/updateelderlyfinanceproject', method: 'post', params: { token: getToken() }, data })
}
// 终止老人收费项目
export function deleteelderlyfinanceproject (data) {
  return request({ url: '/deleteelderlyfinanceproject', method: 'post', params: { token: getToken() }, data })
}
// 查询老人账户列表
export function queryelderlyfinancelist (params, data) {
  params.token = getToken()
  return request({ url: '/queryelderlyfinancelist', method: 'post', params, data })
}
// 设备绑定：整合接口。4G呼叫器绑定到楼层 orgid 有值 sp_id =0 ；手表设备绑定到护工 orgid =0 ，sp_id 有值
export function binddevicenursing (data) {
  return request({ url: '/binddevicenursing', method: 'post', params: { token: getToken() }, data })
}
// 平板绑定账户
export function binddevicetosysuser (data) {
  return request({ url: '/binddevicetosysuser', method: 'post', params: { token: getToken() }, data })
}
// 设备编辑：整合接口。4G呼叫器绑定到楼层 orgid 有值 sp_id =0 ；手表设备绑定到护工 orgid =0 ，sp_id 有值
export function editdevicenursing (data) {
  return request({ url: '/editdevicenursing', method: 'post', params: { token: getToken() }, data })
}
// 员工设备 查询接口
export function querybinddevicetosysperson (params, data) {
  params.token = getToken()
  return request({ url: '/querybinddevicetosysperson', method: 'post', params, data })
}
// 解绑设备：整合接口。4G呼叫器解绑 orgid 有值 sp_id =0 ；护工手表设备解绑 orgid =0 ，sp_id 有值
export function deletedevicenursing (data) {
  return request({ url: '/deletedevicenursing', method: 'post', params: { token: getToken() }, data })
}
// 平板解绑账户
export function unbinddevicetosysuser (data) {
  return request({ url: '/unbinddevicetosysuser', method: 'post', params: { token: getToken() }, data })
}
// 查询服务商人员设备
export function querybinddevicetosupplier (params, data) {
  params.token = getToken()
  return request({ url: '/querybinddevicetosupplier', method: 'post', params, data })
}
// 编辑设备：服务商人员手表设备可以编辑号码
export function editdevicesupplier (data) {
  return request({ url: '/editdevicesupplier', method: 'post', params: { token: getToken() }, data })
}
// 设备绑定：手表设备绑定到服务商人员，sp_id 有值
export function binddevicesupplier (data) {
  return request({ url: '/binddevicesupplier', method: 'post', params: { token: getToken() }, data })
}
// 解绑设备：sp_id 服务商人员需要有值
export function deletedevicesupplier (data) {
  return request({ url: '/deletedevicesupplier', method: 'post', params: { token: getToken() }, data })
}
// 查询餐厅
export function queryrestaurant (params, data) {
  params.token = getToken()
  return request({ url: '/food/restaurant/list', method: 'post', params, data })
}
// 添加餐厅
export function addrestaurant (data) {
  return request({ url: '/food/restaurant/add', method: 'post', params: { token: getToken() }, data })
}
// 更新餐厅
export function updaterestaurant (data) {
  return request({ url: '/food/restaurant/update', method: 'post', params: { token: getToken() }, data })
}
// 删除餐厅
export function deleterestaurant (data) {
  return request({ url: '/food/restaurant/delete', method: 'post', params: { token: getToken() }, data })
}
// 获取食材供应商
export function queryingredientvendor (params, data) {
  params.token = getToken()
  return request({ url: '/food/ingredient-vendor/list', method: 'post', params, data })
}
// 添加食材供应商
export function addingredientvendor (data) {
  return request({ url: '/food/ingredient-vendor/add', method: 'post', params: { token: getToken() }, data })
}
// 更新食材供应商
export function updateingredientvendor (data) {
  return request({ url: '/food/ingredient-vendor/update', method: 'post', params: { token: getToken() }, data })
}
// 删除食材供应商
export function deleteingredientvendor (data) {
  return request({ url: '/food/ingredient-vendor/delete', method: 'post', params: { token: getToken() }, data })
}
// 获取食材供应商附件列表
export function querysupplierfilelist (data) {
  return request({ url: '/misc/attachment/supplier/list', method: 'post', params: { token: getToken() }, data })
}
// 新增、编辑、删除食材供应商附件
export function querysupplierfileupdate (data) {
  return request({ url: '/misc/attachment/supplier/update', method: 'post', params: { token: getToken() }, data })
}
// 获取食材
export function queryingredient (params, data) {
  params.token = getToken()
  return request({ url: '/food/ingredient/list', method: 'post', params, data })
}
// 添加食材
export function addingredient (data) {
  return request({ url: '/food/ingredient/add', method: 'post', params: { token: getToken() }, data })
}
// 更新食材
export function updateingredient (data) {
  return request({ url: '/food/ingredient/update', method: 'post', params: { token: getToken() }, data })
}
// 删除食材
export function deleteingredient (data) {
  return request({ url: '/food/ingredient/delete', method: 'post', params: { token: getToken() }, data })
}
// 获取食材单位
export function queryingredientunit () {
  return request({ url: '/food/ingredientunit/list', method: 'post', params: { token: getToken() } })
}
// 上传图片
export function uploadimage (file) {
  let data = new FormData()
  data.append('file', file.raw)
  return request({url: `/food/upload-image`, method: 'post', params: { token: getToken() }, data})
}
// 获取菜品
export function querydish (params, data) {
  params.token = getToken()
  return request({ url: '/food/dish/list', method: 'post', params, data })
}
// 添加菜品
export function adddish (data) {
  return request({ url: '/food/dish/add', method: 'post', params: { token: getToken() }, data })
}
// 更新菜品
export function updatedish (data) {
  return request({ url: '/food/dish/update', method: 'post', params: { token: getToken() }, data })
}
// 删除菜品
export function deletedish (data) {
  return request({ url: '/food/dish/delete', method: 'post', params: { token: getToken() }, data })
}
// 获取菜品套餐
export function querydishpackage (params, data) {
  params.token = getToken()
  return request({ url: '/food/dish-package/list', method: 'post', params, data })
}
// 添加菜品套餐
export function adddishpackage (data) {
  return request({ url: '/food/dish-package/add', method: 'post', params: { token: getToken() }, data })
}
// 更新菜品套餐
export function updatedishpackage (data) {
  return request({ url: '/food/dish-package/update', method: 'post', params: { token: getToken() }, data })
}
// 删除菜品套餐
export function deletedishpackage (data) {
  return request({ url: '/food/dish-package/delete', method: 'post', params: { token: getToken() }, data })
}
// 查询每周供应
export function querydishweek (params, data) {
  params.token = getToken()
  return request({ url: '/food/dish-week/list', method: 'post', params, data })
}
// 添加每周供应
export function adddishweek (data) {
  return request({ url: '/food/dish-week/add', method: 'post', params: { token: getToken() }, data })
}
// 更新每周供应
export function updatedishweek (data) {
  return request({ url: '/food/dish-week/update', method: 'post', params: { token: getToken() }, data })
}
// 删除每周供应
export function deletedishweek (data) {
  return request({ url: '/food/dish-week/delete', method: 'post', params: { token: getToken() }, data })
}
// 查询安全记录
export function querysafety (params, data) {
  params.token = getToken()
  return request({ url: '/food/food-safety-event/list', method: 'post', params, data })
}
// 添加安全记录
export function addsafety (data) {
  return request({ url: '/food/food-safety-event/add', method: 'post', params: { token: getToken() }, data })
}
// 更新安全记录
export function updatesafety (data) {
  return request({ url: '/food/food-safety-event/update', method: 'post', params: { token: getToken() }, data })
}
// 删除安全记录
export function deletesafety (data) {
  return request({ url: '/food/food-safety-event/delete', method: 'post', params: { token: getToken() }, data })
}

// 获取菜品
export function querydishperson (params, data) {
  params.token = getToken()
  return request({ url: '/food/dish-person/list', method: 'post', params, data })
}
// 添加菜品
export function adddishperson (data) {
  return request({ url: '/food/dish-person/add', method: 'post', params: { token: getToken() }, data })
}
// 更新菜品
export function updatedishperson (data) {
  return request({ url: '/food/dish-person/update', method: 'post', params: { token: getToken() }, data })
}
// 删除菜品
export function deletedishperson (data) {
  return request({ url: '/food/dish-person/delete', method: 'post', params: { token: getToken() }, data })
}

// 获取食品留样
export function queryfoodsample (params, data) {
  params.token = getToken()
  return request({ url: '/food/food-sample/list', method: 'post', params, data })
}
// 添加食品留样
export function addfoodsample (data) {
  return request({ url: '/food/food-sample/add', method: 'post', params: { token: getToken() }, data })
}
// 更新食品留样
export function updatefoodsample (data) {
  return request({ url: '/food/food-sample/update', method: 'post', params: { token: getToken() }, data })
}
// 删除食品留样
export function deletefoodsample (data) {
  return request({ url: '/food/food-sample/delete', method: 'post', params: { token: getToken() }, data })
}
// 上传附件
export function uploadfile (obj) {
  let data = new FormData()
  data.append('file', obj.raw)
  data.append('filename', obj.filename)
  data.append('domain', obj.domain)
  return request60({url: `/updatefileform`, method: 'post', params: { token: getToken() }, data})
}
// 获取人员附件列表
export function querypersonfilelist (data) {
  return request({ url: '/misc/attachment/person/list', method: 'post', params: { token: getToken() }, data })
}
// 新增、编辑、删除人员附件
export function querypersonfileupdate (data) {
  return request({ url: '/misc/attachment/person/update', method: 'post', params: { token: getToken() }, data })
}
// 获取机构文件列表
export function queryentityfilelist (data) {
  return request({ url: '/misc/attachment/entity/list', method: 'post', params: { token: getToken() }, data })
}
// 新增、编辑、删除机构附件
export function queryentityfileupdate (data) {
  return request({ url: '/misc/attachment/entity/update', method: 'post', params: { token: getToken() }, data })
}
// 获取员工附件列表
export function queryservicefilelist (data) {
  return request({ url: '/misc/attachment/serviceperson/list', method: 'post', params: { token: getToken() }, data })
}
// 新增、编辑、删除员工附件
export function queryservicefileupdate (data) {
  return request({ url: '/misc/attachment/serviceperson/update', method: 'post', params: { token: getToken() }, data })
}
// 获取健康监控数据
export function queryroom (params, data) {
  params.token = getToken()
  return request({ url: '/healthdata/queryroom', method: 'post', params, data })
}
// 查询房间及床位
export function queryorghomewithbed (params, data) {
  params.token = getToken()
  return request({ url: '/queryorghomewithbed', method: 'post', params, data })
}
// 获取健康数据
export function queryroomhealth (params, data) {
  params.token = getToken()
  return request({ url: '/healthdata/queryroomhealth', method: 'post', params, data })
}
// 获取健康数据 带参数（参数除了开始结束时间需要一对，其它参数可单独）healthdata/query
export function queryhealthdata (params, data) {
  params.token = getToken()
  return request({ url: '/healthdata/query', method: 'post', params, data })
}
// 获取人员健康数据（养老院）
export function queryhealthqueryperson (params, data) {
  params.token = getToken()
  return request({ url: '/healthdata/queryperson', method: 'post', params, data })
}
// 获取人员健康数据（居家）
export function queryhealthqueryhomeperson (params, data) {
  params.token = getToken()
  return request({ url: '/healthdata/queryhomeperson', method: 'post', params, data })
}
// 新增健康数据（多个数据）
export function queryhealthdatamultiadd (data) {
  return request({ url: '/healthdata/multiadd', method: 'post', params: { token: getToken() }, data })
}
// 获取历史健康数据
export function queryhealthquerypersonhistory (params, data) {
  params.token = getToken()
  return request({ url: '/healthdata/querypersonhistory', method: 'post', params, data })
}
// 获取睡眠记录
export function querysleephistory (params, data) {
  params.token = getToken()
  return request({ url: '/querysleephistory', method: 'post', params, data })
}
// 睡眠报告
export function querysleepreport (data) {
  return request({ url: '/querysleepreport', method: 'post', params: { token: getToken() }, data })
}
// 历史睡眠报告
export function querysleepstatushistory (data) {
  return request60({ url: '/querysleepstatushistory', method: 'post', params: { token: getToken() }, data })
}
// 获取健康数据类型
export function queryhealthdatatype () {
  return request({ url: '/healthdata/querytype', method: 'post', params: { token: getToken() } })
}
// 增加健康数据类型
export function queryhealthdataaddtype (data) {
  return request({ url: '/healthdata/addtype', method: 'post', params: { token: getToken() }, data })
}
// 删除健康数据类型
export function queryhealthdatadeltype (data) {
  return request({ url: '/healthdata/deltype', method: 'post', params: { token: getToken() }, data })
}
// 获取活动管理接口 entertainment_tag 对应 1 老人活动 2 安全活动 3 消防类活动 （活动管理-活动记录（老人活动）)
export function queryelderlyentertainments (params, data) {
  params.token = getToken()
  return request({ url: '/queryelderlyentertainments', method: 'post', params, data })
}
// 添加活动管理
export function addelderlyentertainments (data) {
  return request({ url: '/addelderlyentertainments', method: 'post', params: { token: getToken() }, data })
}
// 更新活动管理
export function updateelderlyentertainments (data) {
  return request({ url: '/updateelderlyentertainments', method: 'post', params: { token: getToken() }, data })
}
// 删除活动管理
export function deleteelderlyentertainments (data) {
  return request({ url: '/deleteelderlyentertainments', method: 'post', params: { token: getToken() }, data })
}
// 查询物资管理 goods_tag 1、固定资产 2、生活物资 3、药品 4、耗材 5、试剂 6、危险源 7、电气 8、用火动火 9、用电防火 10、其它
export function querygoodsentity (params, data) {
  params.token = getToken()
  return request({ url: '/querygoodsentity', method: 'post', params, data })
}
// 添加物资
export function creategoodsentity (data) {
  return request({ url: '/creategoodsentity', method: 'post', params: { token: getToken() }, data })
}
// 更新物资
export function updategoodsentity (data) {
  return request({ url: '/updategoodsentity', method: 'post', params: { token: getToken() }, data })
}
// 删除物资
export function deletegoodsentity (data) {
  return request({ url: '/deletegoodsentity', method: 'post', params: { token: getToken() }, data })
}
// 查询养老院账单
export function queryelderlyfinancestatistics (data) {
  return request({ url: '/queryelderlyfinancestatistics', method: 'post', params: { token: getToken() }, data })
}
// 查询养老院月账单
export function queryelderlyfinancebill (data) {
  return request({ url: '/queryelderlyfinancebill', method: 'post', params: { token: getToken() }, data })
}
// 平板设备 录入设备
export function addpad (data) {
  return request({ url: '/addpad', method: 'post', params: { token: getToken() }, data })
}
// 查询已录入平板设备 新
export function querypadwithuser (params, data) {
  params.token = getToken()
  return request({ url: '/querypadwithuser', method: 'post', params, data })
}
// 查询已录入平板设备 旧
export function querypad (params, data) {
  params.token = getToken()
  return request({ url: '/querypad', method: 'post', params, data })
}
// 平板设备 修改设备
export function editpad (data) {
  return request({ url: '/editpad', method: 'post', params: { token: getToken() }, data })
}
// 加载门禁列表
export function facedevice (data) {
  return request({ url: '/face/device/list', method: 'post', params: { token: getToken() }, data })
}
// 增加、编辑门禁
export function facedeviceadd (data) {
  return request({ url: '/face/device/add', method: 'post', params: { token: getToken() }, data })
}
// 增加、编辑门禁
export function facedeviceupdate (data) {
  return request({ url: '/face/device/update', method: 'post', params: { token: getToken() }, data })
}
// 删除门禁
export function facedevicedelete (data) {
  return request({ url: '/face/device/delete', method: 'post', params: { token: getToken() }, data })
}
// 向门禁发送加载用户列表指令
export function facedeviceuserlist (data) {
  return request({ url: '/face/device/get-user-list', method: 'post', params: { token: getToken() }, data })
}
// 加载门禁的用户列表
export function facepersonlist (params, data) {
  params.token = getToken()
  return request({ url: '/face/person/list', method: 'post', params, data })
}
// 删除门禁用户
export function facepersondelete (data) {
  return request({ url: '/face/person/delete', method: 'post', params: { token: getToken() }, data })
}
// 添加用户信息到门禁
export function facepersonadd (data) {
  return request({ url: '/face/person/add', method: 'post', params: { token: getToken() }, data })
}
// 获取未使用的用户编号
export function faceunusedenrollid (data) {
  return request({ url: '/face/person/get-unused-enroll-id', method: 'post', params: { token: getToken() }, data })
}
// 获取门禁日志
export function facedevicelog (data) {
  return request({ url: '/face/device/get-log', method: 'post', params: { token: getToken() }, data })
}
// 根据personid获取人脸设备
export function facedeviceperson (data) {
  return request({ url: '/face/person/get-devices', method: 'post', params: { token: getToken() }, data })
}
// 查询问卷
export function getsurveylist (params, data) {
  params.token = getToken()
  return request({ url: '/getsurveylist', method: 'post', params, data })
}
// 添加问卷
export function createsurvey (data) {
  return request({ url: '/createsurvey', method: 'post', params: { token: getToken() }, data })
}
// 更新问卷
export function updatesurvey (data) {
  return request({ url: '/updatesurvey', method: 'post', params: { token: getToken() }, data })
}
// 删除问卷
export function deletesurvey (data) {
  return request({ url: '/deletesurvey', method: 'post', params: { token: getToken() }, data })
}



// WEBPACK FOOTER //
// ./src/api/yanglaoyuan.js